import { staticText } from '../../../../utils/translations/staticText';

// Module-owned strings of the PL Offers section (CMS-2023 §5.1). `zh` serves
// zh-tw (Money101); Hong Kong has its own `zh-hk` copy. Keys with only `_`
// have no approved ZH copy yet and render in English on ZH pages.
export const TRANSLATIONS = staticText({
  amount_and_above: {
    _: ':amount and above',
  },
  back_to_loan_details: {
    _: 'Back to loan details',
    zh: '返回貸款詳情',
    'zh-hk': '返回貸款詳情',
  },
  calculator_note: {
    _: 'Amount and tenure are set by the calculator above; rewards update as you change them.',
    zh: '金額及還款期限由上方計算機設定，調整後好禮會即時更新。',
    'zh-hk': '金額及還款期由上方計算機設定，調整後獎賞會即時更新。',
  },
  choose_one_of: {
    _: 'Choose 1 of :count',
    zh: ':count 項好禮擇一',
    'zh-hk': ':count 選 1',
  },
  // :amount already carries the market currency, so the ticket's "NT$[amount]"
  // (zh) becomes ":amount".
  lead_in: {
    _: 'Based on your :product of :amount over :count months',
    zh: '以 :product 申請 :amount，分 :count 個月攤還，申辦及達指定條件即享有以下優惠',
    'zh-hk': ':product：貸款額 :amount，還款期 :count 個月，你將享有以下優惠',
  },
  loan_amount: {
    _: 'Loan amount',
    zh: '貸款金額',
    'zh-hk': '貸款額',
  },
  matrix_heading: {
    _: 'All loan amounts and tenures',
    zh: '其他貸款金額及還款期限',
    'zh-hk': '其他貸款額及還款期',
  },
  max_rewards: {
    _: 'Max rewards',
    zh: '最高可享好禮',
    'zh-hk': '最高可享獎賞',
  },
  not_available: {
    _: 'Not available for your selection',
    zh: '不適用於您的選擇',
    'zh-hk': '不適用於你的選擇',
  },
  // Reminder in place of the total when no offer matches (CMS-2023 §7); the
  // singular "month" is the ticket's copy (Gherkin 12e).
  reminder_amount: {
    _: 'Update your loan amount to at least :amount to unlock exclusive gifts.',
    zh: '請將您的貸款金額調整至至少 :amount，以解鎖獨家好禮。',
    'zh-hk': '請將您的貸款額調整至至少 :amount，以解鎖獨家禮品。',
  },
  reminder_amount_and_tenure: {
    _: 'Update your loan amount to at least :amount and loan tenure to at least :count month to unlock exclusive gifts worth up to :value.',
    zh: '請將您的貸款金額調整至至少 :amount，並將還款期限更新至至少 :count 個月，以解鎖最高可獲得 :value 的獨家好禮。',
    'zh-hk':
      '請將您的貸款額調整至至少 :amount，並將還款期更新至至少 :count 個月，以解鎖最高可獲得 :value 的獨家禮品。',
  },
  reminder_tenure: {
    _: 'Update your loan tenure to at least :count month to unlock exclusive gifts.',
    zh: '請將還款期限更新至至少 :count 個月，以解鎖獨家好禮。',
    'zh-hk': '請將還款期更新至至少 :count 個月，以解鎖獨家禮品。',
  },
  rewards_up_to: {
    _: 'Rewards up to',
    zh: '好禮最高',
    'zh-hk': '獎賞高達',
  },
  see_details: {
    _: 'see details',
    zh: '見詳情',
    'zh-hk': '見詳情',
  },
  see_more: {
    _: 'See more',
    zh: '查看更多優惠詳情',
    'zh-hk': '查看更多優惠詳情',
  },
  tenure_months: {
    _: ':count months',
  },
  terms_and_conditions: {
    _: 'Terms and conditions',
    zh: '注意事項',
    'zh-hk': '條款及細則',
  },
  // Shown from the "Max rewards" total on the summary card (CMS-2023 §9, Gherkin 13).
  total_footnote: {
    _: "Within one offer, rewards are choose-one and never added together. Whether rewards from different offers can be enjoyed together is subject to each offer's own terms and conditions.",
    zh: '同一優惠內的好禮只可選擇 1 項，不會相加。不同優惠能否同時享有，以各優惠之條款及細則為準。',
    'zh-hk':
      '同一優惠內的獎賞只可選擇 1 項，不會相加。不同優惠能否同時享有，以各優惠之條款及細則為準。',
  },
  under_12_months: {
    _: 'Under 12 months',
    zh: '低於 12 個月',
    'zh-hk': '低於 12 個月',
  },
  up_to_value: {
    _: 'up to :value',
    zh: '最高 :value',
    'zh-hk': '高達 :value',
  },
  worth_value: {
    _: 'Worth :value',
    zh: '價值 :value',
    'zh-hk': '價值 :value',
  },
});

/** Resolved module strings of the Offers section. */
export type OffersPlText = Record<keyof typeof TRANSLATIONS, string>;
